/**
 * @file: SidebarCreditBalance.tsx
 * @copyright: (c) 2019-2020 sichuan zhichetech co., ltd.
 */

import { useAiTrialEndsAt } from '@euler/functions/entitlements/useAiTrialEndsAt';
import { memo } from 'react';
import { SidebarCreditBalanceLabel } from './SidebarCreditBalanceLabel';

/**
 * The AI credits left, under 知车AI's label in the drawer and the sidebar,
 * while the store is trying AI (`useAiTrialEndsAt`); the label (and its
 * fetch) mounts only then.
 */
export const SidebarCreditBalance = memo(({ color }: { color: string }) => {
  return useAiTrialEndsAt() != null ? (
    <SidebarCreditBalanceLabel color={color} />
  ) : null;
});
